import { render } from "./ModalSelectFreeItem.vue?vue&type=template&id=71458e6b&scoped=true"
import script from "./ModalSelectFreeItem.vue?vue&type=script&lang=js"
export * from "./ModalSelectFreeItem.vue?vue&type=script&lang=js"

import "./ModalSelectFreeItem.vue?vue&type=style&index=0&id=71458e6b&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71458e6b"]])

export default __exports__